// Mounts the app inside the root error boundary (docs/ARCHITECTURE.md §2.6).
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "maplibre-gl/dist/maplibre-gl.css";
import "./shared/tokens.css";
import "./app/global.css";
import { App } from "./app/App";
import { ErrorBoundary } from "./app/ErrorBoundary";
import { startReporting } from "./app/report";

startReporting();

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root");
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary region="app">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
